import { useRouteError } from 'react-router-dom';

export default function ErrorPage() {
    const error: any = useRouteError();

    return (
        <div style={{ padding: '2rem', fontFamily: 'Inter, sans-serif' }}>
            <h2>Something went wrong</h2>
            <p>{error?.statusText || error?.message || 'An unexpected error occurred.'}</p>
        </div>
    );
}
